
export default function itemUpdate(item, updated, properties) {
  Object.keys(updated).map((property) => {
    const prop = properties[property]
    if (prop === undefined) {
      console.warn('Unknown property ' + property + ' for update - ignored.')
      return
    }
    if (updated[property] === undefined) {
      throw new Error('Values MUST NOT be undefined, use null instead: ' + property)
    }
    let newValue = undefined
    switch (prop.type) {
      case 'array':
        // FIXME: do we need to walk the elements?
        newValue = updated[property]
        break
      case 'string':
        switch (prop.format) {
          case 'date-time':
            // FIXME: need a way to distinguish between date and datetime.
            newValue = updated[property]
            break
          default:
            newValue = updated[property]
        }
        break
      case 'integer':
        newValue = parseInt(updated[property])
        break
      case 'number':
        newValue = updated[property] ? parseFloat(updated[property]) : (updated[property] === 0 ? 0 : null)
        break
      default:
        throw new Error('Unknown type ' + prop.type + ' for property ' + property)
    }
    if (item[property] !== newValue) {
      item[property] = newValue
    }
  })
}
